import request from '@/utils/request2'

// 列表(主数据列表)
export function loadMarketReportPeriodListDataApi(data) {
  return request({
    url: 'tms-web/marketReportPeriod/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportMarketReportPeriodListDataApi(data) {
  return request({
    url: 'tms-web/marketReportPeriod/exportByPage',
    method: 'post',
    data
  })
}

// 保存
export function saveMarketReportPeriodApi(data) {
  return request({
    url: 'tms-web/marketReportPeriod/save',
    method: 'post',
    data
  })
}

// 作废
export function deleteMarketReportPeriodApi(data) {
  return request({
    url: 'tms-web/marketReportPeriod/delete',
    method: 'post',
    data
  })
}

// 查看
export function viewMarketReportPeriodApi(data) {
  return request({
    url: 'tms-web/marketReportPeriod/view',
    method: 'post',
    data
  })
}

// 列表
export function listMarketReportPeriodApi(data) {
  return request({
    url: 'tms-web/marketReportPeriod/list',
    method: 'post',
    data
  })
}
